module.exports = "/_next/static/images/primary-circle-blurred-2048x2048px-786b9d901a404504f4d2fe3ad0c846bf.png";